import { render, staticRenderFns } from "./ObjectsTable.vue?vue&type=template&id=6b9b9db3&scoped=true"
import script from "./ObjectsTable.vue?vue&type=script&lang=ts"
export * from "./ObjectsTable.vue?vue&type=script&lang=ts"
import style0 from "./ObjectsTable.vue?vue&type=style&index=0&id=6b9b9db3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9b9db3",
  null
  
)

export default component.exports